export default __webpack_public_path__ + "static/media/Handguards of Infernal Zeal.94bf8ee3.jpg";